import { Box } from "@mui/material";
import { useDarkMode } from "../../contexts/ThemeContext";
import { useTranslation } from "react-i18next";
import "../../style/ChangeLanguageButton.css";

// change language button in the footer
const ChangeLanguageButton = () => {
  const { darkMode } = useDarkMode();
  const { i18n } = useTranslation();

  const languageOptions = [
    { code: "en", label: "EN", flagUrl: "https://flagcdn.com/w40/gb.png" },
    { code: "fr", label: "FR", flagUrl: "https://flagcdn.com/w40/fr.png" },
  ];

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
  };

  return (
    <Box className="language-switcher">
      {languageOptions.map((lang, index) => (
        <button
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
          className={`language-button ${
            i18n.language === lang.code ? "active" : ""
          } ${darkMode ? "dark-mode" : "light-mode"} ${
            index === 0 ? "left" : "right"
          }`}
        >
          <img
            src={lang.flagUrl}
            alt={`${lang.label} flag`}
            className="language-flag"
            style={{
              width: "20px",
              height: "15px",
              objectFit: "cover",
              borderRadius: "2px",
            }}
          />
          <span className="language-label">{lang.label}</span>
        </button>
      ))}
    </Box>
  );
};

export default ChangeLanguageButton;
